import { ParticipantResponse } from '../../../../types/adminApi/events'

export const formatParticipantName = (participant: ParticipantResponse) => {
  let name = participant.firstName
  if (participant.lastName) {
    name += ` ${participant.lastName}`
  }
  return name
}
